export interface RequestGenerationGate {
  begin(): number;
  invalidate(): void;
  isCurrent(generation: number): boolean;
}

export function createRequestGenerationGate(): RequestGenerationGate {
  let current = 0;
  return {
    begin: () => ++current,
    invalidate: () => { current += 1; },
    isCurrent: (generation) => generation === current,
  };
}
